/* Maison Intègre - interactions communes (Della Mattia) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Horizon fait défiler .page-wrapper et non window : on retrouve le vrai conteneur de scroll */
  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw) {
      var ov = getComputedStyle(pw).overflowY;
      if ((ov === 'auto' || ov === 'scroll') && pw.scrollHeight > pw.clientHeight + 1) return pw;
    }
    return document.scrollingElement || document.documentElement;
  }

  /* Slider d'images des cartes produit */
  function initCards(root) {
    root.querySelectorAll('[data-mi-card]').forEach(function (card) {
      if (card.dataset.miReady) return;
      card.dataset.miReady = '1';
      var track = card.querySelector('[data-mi-card-track]');
      if (!track) return;
      var slides = track.children.length;
      var progress = card.querySelector('.mi-card__progress span');
      var prev = card.querySelector('[data-mi-card-prev]');
      var next = card.querySelector('[data-mi-card-next]');

      function index() {
        return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      }
      function go(i) {
        if (i < 0) i = slides - 1;
        if (i >= slides) i = 0;
        track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      function stop(e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (prev) prev.addEventListener('click', function (e) { stop(e); go(index() - 1); });
      if (next) next.addEventListener('click', function (e) { stop(e); go(index() + 1); });
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          if (progress) progress.style.setProperty('--mi-index', index());
        });
      }, { passive: true });
    });
  }

  /* Lire la suite */
  function initReadMore(root) {
    root.querySelectorAll('[data-mi-readmore]').forEach(function (el) {
      if (el.dataset.miReady) return;
      el.dataset.miReady = '1';
      var btn = el.querySelector('[data-mi-readmore-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* Apparition au scroll */
  var revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px 6% 0px' }) : null;

  function initReveal(root) {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    root.querySelectorAll('.mi-reveal:not(.is-visible)').forEach(function (el) {
      /* Déjà à l'écran : visible tout de suite, sans fondu, avant le premier rendu */
      var r = el.getBoundingClientRect();
      if (!revealObserver || reduceMotion || (r.top < vh && r.bottom > 0)) {
        el.classList.add('is-instant', 'is-visible');
        return;
      }
      revealObserver.observe(el);
    });
    /* Le masquage CSS ne s'active qu'une fois les éléments visibles marqués */
    document.documentElement.classList.add('mi-js');
  }

  /* Vidéos : lecture seulement quand elles sont visibles */
  var videoObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting) {
        if (v.dataset.miUserPaused === '1') return;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.15 }) : null;

  function initVideos(root) {
    if (reduceMotion || !videoObserver) return;
    root.querySelectorAll('video[data-mi-autoplay]').forEach(function (v) {
      if (v.dataset.miReady) return;
      v.dataset.miReady = '1';
      v.muted = true;
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      videoObserver.observe(v);
    });
  }

  /* Sliders : diptyque / triptyque en mobile, grilles de produits en carrousel */
  function initMediaSliders(root) {
    root.querySelectorAll('[data-mi-slider]').forEach(function (slider) {
      if (slider.dataset.miReady) return;
      slider.dataset.miReady = '1';
      var track = slider.querySelector('[data-mi-slider-track]');
      var dots = slider.querySelectorAll('[data-mi-slider-dot]');
      if (!track) return;
      function index() {
        var first = track.children[0];
        var w = first ? first.getBoundingClientRect().width : track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return Math.round(track.scrollLeft / Math.max(w + gap, 1));
      }
      function go(i) {
        var items = track.children;
        if (!items.length) return;
        if (i < 0) i = items.length - 1;
        if (i >= items.length) i = 0;
        track.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      /* Plusieurs éléments visibles : en fin de piste on revient au début, et inversement */
      function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
      function atStart() { return track.scrollLeft <= 4; }
      function step(dir) {
        if (dir > 0 && atEnd()) { go(0); return; }
        if (dir < 0 && atStart()) { track.scrollTo({ left: track.scrollWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); return; }
        go(index() + dir);
      }
      /* Flèches masquées quand tout tient à l'écran */
      function sync() { slider.classList.toggle('is-static', track.scrollWidth <= track.clientWidth + 4); }
      sync();
      window.addEventListener('resize', sync, { passive: true });
      slider.querySelectorAll('[data-mi-slider-prev]').forEach(function (b) { b.addEventListener('click', function () { step(-1); }); });
      slider.querySelectorAll('[data-mi-slider-next]').forEach(function (b) { b.addEventListener('click', function () { step(1); }); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      track.addEventListener('scroll', function () {
        var i = index();
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      }, { passive: true });
    });
  }

  /* Bouton Enter du splash : descend à la section suivante */
  function initEnter(root) {
    root.querySelectorAll('[data-mi-enter]').forEach(function (btn) {
      if (btn.dataset.miReady) return;
      btn.dataset.miReady = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var section = btn.closest('.shopify-section');
        var nextSection = section && section.nextElementSibling;
        if (!nextSection) return;
        var header = document.querySelector('.mi-header');
        var offset = header ? header.offsetHeight : 0;
        var sc = scroller();
        var top = nextSection.getBoundingClientRect().top + sc.scrollTop - offset;
        sc.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  }

  /* Parallaxe légère sur les médias marqués .mi-parallax */
  var parallaxEls = [];
  var parallaxTick = false;
  function updateParallax() {
    parallaxTick = false;
    var vh = window.innerHeight;
    parallaxEls.forEach(function (frame) {
      var r = frame.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      var shift = Math.max(-1, Math.min(1, p)) * r.height * 0.07;
      frame.querySelectorAll('img, video').forEach(function (m) {
        m.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
      });
    });
  }
  function requestParallax() {
    if (!parallaxTick) { parallaxTick = true; requestAnimationFrame(updateParallax); }
  }
  function initParallax(root) {
    if (reduceMotion) return;
    root.querySelectorAll('.mi-parallax').forEach(function (el) {
      if (parallaxEls.indexOf(el) === -1) parallaxEls.push(el);
    });
    if (!initParallax.bound) {
      initParallax.bound = true;
      window.addEventListener('scroll', requestParallax, { passive: true });
      var pw = document.querySelector('.page-wrapper');
      if (pw) pw.addEventListener('scroll', requestParallax, { passive: true });
      window.addEventListener('resize', requestParallax);
    }
    requestParallax();
  }

  /* Bouton pause / lecture des vidéos d'une section */
  function initPause(root) {
    root.querySelectorAll('[data-mi-pause]').forEach(function (btn) {
      if (btn.dataset.miReady) return;
      btn.dataset.miReady = '1';
      var scope = btn.closest('[data-mi-video-scope]') || btn.parentElement;
      btn.addEventListener('click', function () {
        var paused = btn.getAttribute('aria-pressed') === 'true';
        scope.querySelectorAll('video').forEach(function (v) {
          if (paused) {
            v.dataset.miUserPaused = '';
            var pr = v.play();
            if (pr && pr.catch) pr.catch(function () {});
          } else {
            v.dataset.miUserPaused = '1';
            v.pause();
          }
        });
        btn.setAttribute('aria-pressed', paused ? 'false' : 'true');
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initCards(root);
    initReadMore(root);
    initReveal(root);
    initVideos(root);
    initMediaSliders(root);
    initEnter(root);
    initParallax(root);
    initPause(root);
  }

  window.MI = window.MI || {};
  window.MI.init = initAll;
  window.MI.scroller = scroller;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  /* Liens d'ancre (ex. See the pieces) : défilement doux sous le header */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-mi-anchor][href^="#"]');
    if (!a) return;
    var target = document.querySelector(a.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    var header = document.querySelector('.mi-header');
    var offset = header ? header.offsetHeight : 0;
    var sc = scroller();
    var top = target.getBoundingClientRect().top + sc.scrollTop - offset;
    sc.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
})();
